// import SaleUtils from '@/services/SaleUtils'
// import { required } from '@/services/validations'
// import BranchOfficeMdl from '@/models/General/GBranchOffice'
// import BranchOfficeService from '@/services/api/branchOffice'
import ProductPricesHeaders from './headersPrice'
import ProductPercentageHeaders from './headersPercentage'
// const fetchBranch = ()=>{
//   BranchOfficeService.fetchAll().then(r=>{
//     return r
//   })
// }
// Fields to Comercial Information
export default (discountType)=>[
    {
        name: 'whole_sale_selected',
        type: 'tableField',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: discountType==='price' ? ProductPricesHeaders : ProductPercentageHeaders ,
            noActions: true,
            noDataText: 'Sin esquemas.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,

            showNativePagination: true,
            //showPicker: true,
            style: {
                //margin: "0 -24px"
            },
            showRemove: true,
            toolbarTitle: 'Detalle descuento de precios por cantidad',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            noRefresh : true,
        },
    },
]
